<template>
    <div v-if="incident">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h2>
                    <icon
                        name="info"
                        class="text-info icon"
                        title="Component is up."
                        v-if="incident.isComponentDown"
                    ></icon>
                    <icon
                        name="exclamation-triangle"
                        class="text-danger icon"
                        title="Component is down."
                        v-else
                    ></icon>
                    On {{ getIncidentStartDate(incident) | date }}
                    <div class="pull-right" v-if="isAuthenticated">
                        <span class="edit">
                            <router-link :to="`/incidents/${incident.id}/edit`">
                                <icon name="edit" class="icon icon--small" title="Edit"></icon>
                                <small class="icon-label">Edit</small>
                            </router-link>
                        </span>
                    </div>
                </h2>
                <hr />
            </div>
        </div>

        <div class="bootstrap-iso">
            <div class="container-fluid" v-if="incident">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h3>
                            <small>Details</small>
                        </h3>
                        <div>
                            <h5>
                                <strong>Affected compoment:</strong>
                                {{ component.name }}
                                <span
                                    v-if="incident.isScheduled"
                                >
                                    <i>(Scheduled maintance)</i>
                                </span>
                            </h5>
                        </div>
                        <div v-if="incident.startDate && incident.endDate">
                            <h5>
                                <strong>Duration:</strong>
                                This incident was reported on
                                <strong>
                                    <i>{{ incident.startDate | datetime }}</i>
                                </strong> and was resolved on
                                <strong>
                                    <i>{{ incident.endDate | datetime }}</i>
                                </strong>.
                            </h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h3>
                            <small>Notifications</small>
                        </h3>
                        <div class="row list-incident-messages">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <blockquote
                                    class="blockquote"
                                    v-for="message in incident.messages"
                                    v-bind:key="message.id"
                                >
                                    <p
                                        class="mb-0"
                                        v-for="line in message.body.split(/\r?\n/)"
                                        v-bind:key="line"
                                    >
                                        {{ line }}<br/>
                                    </p>
                                    <footer class="blockquote-footer">
                                        <span>
                                            Posted on {{ message.postedAt | date }} at {{ message.postedAt | time }} UTC
                                            &nbsp;
                                        </span>
                                    </footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../store"
import { mapGetters, mapActions } from "vuex"
import { NotificationsMixin } from "./mixin"

export default {
    name: "IncidentDetails",
    mixins: [NotificationsMixin],
    computed: {
        ...mapGetters({
            components: "getComponents",
            incident: "getIncident",
            isAuthenticated: "isAuthenticated"
        }),
        component() {
            return this.components.find(c => c.id === this.incident.componentId)
        }
    },
    methods: {
        getIncidentStartDate(incident) {
            if (incident.startDate) {
                return incident.startDate
            } else {
                return incident.messages[0].postedAt
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("loadIncident", to.params.id).then(res => next())
    }
}
</script>

<style scoped>
.icon {
    text-align: center;
    width: 25px;
    height: 25px;
}

a:hover {
    text-decoration: none;
}

.icon--small {
    width: 16px;
}

.icon-label {
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/IncidentDetails.vue